import {PlayerReduxState} from "../types";
import {Challenge} from "../../../schema";

export default function getChallenge(state: PlayerReduxState): Challenge {
  return state.challenge;
}
